import React, { FC, Fragment, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Unstable_Grid2 as Grid,
  Typography,
  Box,
  TableRow,
  TableCell,
  Table,
  TableBody,
} from '@mui/material';
import { times } from 'lodash';
import moment from 'moment';

import { EmptyState, LoaderComponents, PaddedPaper, Insights } from 'components';
import { useGetOiCtaPeopleQuery } from 'api';
import { useNotify } from 'hooks';

import { Tables } from '../components';

const InsightsLanding: FC = () => {
  const { t } = useTranslation();
  const notify = useNotify();

  const [peopleStartTime] = useState(moment().subtract('1', 'year').unix());
  const [endTime] = useState(moment().unix());

  const { data: peopleData, isLoading: isPeopleLoading } = useGetOiCtaPeopleQuery(
    {
      start: peopleStartTime,
      end: endTime,
      limit: 20,
    },
    {
      onError: notify.queryError,
    }
  );

  function renderPeopleLoader() {
    return (
      <Box marginY={8}>
        <PaddedPaper>
          <Table>
            <TableBody>
              {times(6, rowIndex => (
                <TableRow key={rowIndex}>
                  <TableCell colSpan={6}>
                    <LoaderComponents.Content index={rowIndex} height={15} maxWidth={400} />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </PaddedPaper>
      </Box>
    );
  }

  function renderIntel() {
    return (
      <Fragment>
        <Grid container direction="column" spacing={3} alignItems="center">
          <Grid xs={12} sm={8}>
            <Insights.IntelligenceHeader variant="large" />
          </Grid>
          <Grid>
            <Insights.CTAButton text={t('insights:abm_page_cta')} variant="large" />
          </Grid>
        </Grid>
      </Fragment>
    );
  }

  function renderPeople() {
    if (isPeopleLoading) {
      return renderPeopleLoader();
    }

    return (
      <Fragment>
        <Box marginY={8}>
          {!results.length ? (
            <EmptyState name="insightsPeople" />
          ) : (
            <PaddedPaper>
              <Tables.Landing results={results} />
            </PaddedPaper>
          )}
        </Box>
        <Grid container direction="column" spacing={3} alignItems="center">
          <Grid xs={12} sm={8}>
            <Typography variant="h2" align="center">
              {t('insights:abm_footer')}
            </Typography>
          </Grid>
          <Grid>
            <Insights.CTAButton text={t('insights:abm_page_cta')} variant="large" />
          </Grid>
        </Grid>
      </Fragment>
    );
  }

  const { results = [] } = peopleData?.getPeople || {};

  return (
    <Box marginTop={4} marginBottom={8}>
      {renderIntel()}
      {renderPeople()}
    </Box>
  );
};

export default InsightsLanding;
